import React from "react";
import { observer } from "mobx-react";
import { withStyles } from "@material-ui/styles";
import { toJS } from "mobx";
import { withAlert } from "react-alert";

import Layout from "../../components/Layout";

import WorkIcon from "@material-ui/icons/Work";
import StarIcon from "@material-ui/icons/Star";
import IconButton from "@material-ui/core/IconButton";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import location from "../../stores/locationStore";
import DeleteIcon from "@material-ui/icons/Delete";
import Modal from "@material-ui/core/Modal";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

import ReactDiffViewer, { DiffMethod } from "react-diff-viewer";

import SwipeableViews from "react-swipeable-views";
import { Paper, FormControlLabel, Switch } from "@material-ui/core";

var cloneDeep = require("lodash.clonedeep");
const styles = (theme) => ({
  tableContainer: {
    marginTop: 20,
  },
});
const newStyles = {
  variables: {
    light: {
      addedBackground: "#fff",
      removedBackground: "#fff",
    },
    dark: {
      highlightBackground: "#fefed5",
      highlightGutterBackground: "#ffcd3c",
    },
  },
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}
const View = observer(
  class History extends React.Component {
    constructor(props) {
      super(props);
      this.state = { history: [], value: 0, isSplit: false };
      this.handleClick = this.handleClick.bind(this);
    }
    componentDidMount = async () => {
      await location.getHistory(this.props.match.params.locname);
    };
    handleClick = async (locname, item) => {
      await location.deleteHistory(locname, item);
    };
    handleChange = (e, newValue) => {
      this.setState({ value: newValue });
    };
    handleSwitch = (e) => {
      this.setState({
        [e.target.name]: e.target.checked,
      });
    };
    render() {
      // const { classes } = this.props;
      const { locname } = this.props.match.params;
      const history = toJS(location.history);
      const detailDiff = history.filter((item) => item.title == "서버 Detail");
      const newCode =
        detailDiff.length >= 2
          ? JSON.stringify(detailDiff[0]["content"], null, 1)
          : "";
      const oldCode =
        detailDiff.length >= 2
          ? JSON.stringify(detailDiff[1]["content"], null, 1)
          : "";
      const DetailDiffView =
        detailDiff.length >= 2 ? (
          <ReactDiffViewer
            styles={newStyles}
            oldValue={oldCode}
            newValue={newCode}
            splitView={this.state.isSplit}
            leftTitle={
              this.state.isSplit
                ? "이전 내용 작성자:" +
                  detailDiff[1]["subtitle"].replace("Update", "")
                : "스플릿뷰를 활성화시키면 작성자를 확인할 수 있습니다."
            }
            rightTitle={
              "최신 내용 작성자:" +
              detailDiff[0]["subtitle"].replace("Update", "")
            }
          />
        ) : (
          <Box>
            <Typography>비교 내용을 찾을 수 없습니다.</Typography>
          </Box>
        );
      const ServerDiff = cloneDeep(
        history.filter((item) => {
          if (item.title == "서버업데이트" || item.title == "서버추가") {
            return item;
          }
        })
      );
      ServerDiff.map((item) => {
        delete item.content["_id"];
        delete item.content["__v"];
      });

      let gubunList = Array.from(
        new Set(
          ServerDiff.map((item) => {
            return item.content["gubun"];
          })
        )
      );
      const gubunView = (
        <Box>
          {gubunList.map((item) => {
            var gubunHistory = ServerDiff.filter(
              (item2) => item2.content["gubun"] == item
            );
            if (gubunHistory.length >= 2) {
              var nCode = JSON.stringify(gubunHistory[0]["content"], null, 1);
              var oCode = JSON.stringify(gubunHistory[1]["content"], null, 1);

              if (nCode == oCode) {
                return (
                  <Paper style={{ marginBottom: 20 }}>
                    <Typography>{item}은 변경된 내역이 없습니다.</Typography>
                  </Paper>
                );
              }
              return (
                <Paper style={{ marginBottom: 20 }} key={item}>
                  <Typography>{item}</Typography>
                  <ReactDiffViewer
                    styles={newStyles}
                    oldValue={oCode}
                    newValue={nCode}
                    splitView={this.state.isSplit}
                    leftTitle={
                      this.state.isSplit
                        ? "이전 내용 작성자:" +
                          gubunHistory[1]["subtitle"]
                            .replace("Update", "")
                            .replace("Create", "")
                        : "스플릿뷰를 활성화시키면 작성자를 확인할 수 있습니다."
                    }
                    rightTitle={
                      "최신 내용 작성자:" +
                      gubunHistory[0]["subtitle"]
                        .replace("Update", "")
                        .replace("Create", "")
                    }
                  />
                </Paper>
              );
            } else {
              return <Typography>{item}은 비교할 내역이 없습니다.</Typography>;
            }
          })}
        </Box>
      );

      const ServerDiffView = gubunList ? (
        gubunView
      ) : (
        <Box>
          <Typography>비교 내용을 찾을 수 없습니다.</Typography>
        </Box>
      );

      const TimeLine = (
        <VerticalTimeline layout="1-column">
          {history.map((item) => (
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              date={item.date}
              iconStyle={{ background: "rgb(33, 150, 243)", color: "#fff" }}
              icon={<WorkIcon />}
              key={item.title + item.date}
            >
              <h3 className="vertical-timeline-element-title">{item.title}</h3>
              <h4 className="vertical-timeline-element-subtitle">
                {item.subtitle}
              </h4>
              <p>{JSON.stringify(item.content)}</p>
              {item.title !== "Error" && (
                <IconButton
                  color="secondary"
                  aria-label="add an alarm"
                  onClick={async () => {
                    this.handleClick(locname, item);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </VerticalTimelineElement>
          ))}
          {/* <VerticalTimelineElement
        className="vertical-timeline-element--education"
        date="2002 - 2006"
        iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
        icon={<SchoolIcon />}
      >
        <h3 className="vertical-timeline-element-title">
          Bachelor of Science in Interactive Digital Media Visual Imaging
        </h3>
        <h4 className="vertical-timeline-element-subtitle">
          Bachelor Degree
        </h4>
        <p>Creative Direction, Visual Design</p>
      </VerticalTimelineElement> */}
          <VerticalTimelineElement
            iconStyle={{ background: "rgb(16, 204, 82)", color: "#fff" }}
            icon={<StarIcon />}
          />
        </VerticalTimeline>
      );
      return (
        <Layout>
          <Typography>{locname} history</Typography>
          <FormControlLabel
            control={
              <Switch
                checked={this.state.isSplit}
                onChange={this.handleSwitch}
                name="isSplit"
                color="primary"
              />
            }
            label="스플릿뷰"
          />
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab label="타임라인" {...a11yProps(0)} />
            <Tab label="서버" {...a11yProps(1)} />
            <Tab label="서버Detail" {...a11yProps(2)} />
          </Tabs>
          <SwipeableViews
            index={this.state.value}
            onChangeIndex={(index) => {
              this.setState({ value: index });
            }}
          >
            <TabPanel value={this.state.value} index={0}>
              {TimeLine}
            </TabPanel>
            <TabPanel value={this.state.value} index={1}>
              {ServerDiffView}
            </TabPanel>
            <TabPanel value={this.state.value} index={2}>
              {DetailDiffView}
            </TabPanel>
          </SwipeableViews>
        </Layout>
      );
    }
  }
);

const alertView = withAlert()(View);
export default withStyles(styles)(alertView);
